/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  PostTournamentsRegisterSoloMutationRequest,
  PostTournamentsRegisterSoloMutationResponse,
  PostTournamentsRegisterSolo400,
  PostTournamentsRegisterSolo401,
  PostTournamentsRegisterSolo500,
} from "../types/PostTournamentsRegisterSolo.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postTournamentsRegisterSoloMutationKey = () =>
  [{ url: "/tournaments/register/solo" }] as const;

export type PostTournamentsRegisterSoloMutationKey = ReturnType<
  typeof postTournamentsRegisterSoloMutationKey
>;

/**
 * @description Используется для турниров с типом Draft.
 * Игрок указывает желаемую роль и хочет ли быть капитаном.
 * @summary Регистрация индивидуального игрока на турнир (Draft Mode)
 * {@link /tournaments/register/solo}
 */
export async function postTournamentsRegisterSolo(
  data: PostTournamentsRegisterSoloMutationRequest,
  config: Partial<RequestConfig<PostTournamentsRegisterSoloMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostTournamentsRegisterSoloMutationResponse,
    ResponseErrorConfig<
      | PostTournamentsRegisterSolo400
      | PostTournamentsRegisterSolo401
      | PostTournamentsRegisterSolo500
    >,
    PostTournamentsRegisterSoloMutationRequest
  >({
    method: "POST",
    url: `/tournaments/register/solo`,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res;
}

export function postTournamentsRegisterSoloMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostTournamentsRegisterSoloMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postTournamentsRegisterSoloMutationKey();
  return mutationOptions<
    ResponseConfig<PostTournamentsRegisterSoloMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterSolo400
      | PostTournamentsRegisterSolo401
      | PostTournamentsRegisterSolo500
    >,
    { data: PostTournamentsRegisterSoloMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postTournamentsRegisterSolo(data, config);
    },
  });
}

/**
 * @description Используется для турниров с типом Draft.
 * Игрок указывает желаемую роль и хочет ли быть капитаном.
 * @summary Регистрация индивидуального игрока на турнир (Draft Mode)
 * {@link /tournaments/register/solo}
 */
export function usePostTournamentsRegisterSolo<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<PostTournamentsRegisterSoloMutationResponse>,
      ResponseErrorConfig<
        | PostTournamentsRegisterSolo400
        | PostTournamentsRegisterSolo401
        | PostTournamentsRegisterSolo500
      >,
      { data: PostTournamentsRegisterSoloMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostTournamentsRegisterSoloMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postTournamentsRegisterSoloMutationKey();

  const baseOptions = postTournamentsRegisterSoloMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<PostTournamentsRegisterSoloMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterSolo400
      | PostTournamentsRegisterSolo401
      | PostTournamentsRegisterSolo500
    >,
    { data: PostTournamentsRegisterSoloMutationRequest },
    TContext
  >;

  return useMutation<
    ResponseConfig<PostTournamentsRegisterSoloMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterSolo400
      | PostTournamentsRegisterSolo401
      | PostTournamentsRegisterSolo500
    >,
    { data: PostTournamentsRegisterSoloMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<PostTournamentsRegisterSoloMutationResponse>,
    ResponseErrorConfig<
      | PostTournamentsRegisterSolo400
      | PostTournamentsRegisterSolo401
      | PostTournamentsRegisterSolo500
    >,
    { data: PostTournamentsRegisterSoloMutationRequest },
    TContext
  >;
}
